import React from 'react';
import { UserAccountSummary } from '~domain/model/account/user-account-summary';
import { PolicySummaryFacade } from '~domain/model/facade/policy/policy-summary-facade';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Grid, GridProps } from '~ui-kit/components/grid';
import { ActionType } from './models/policy-modification-config';
import { PolicyModificationCard } from './policy-modification-card/policy-modification-card';
import { policyModificationOptions } from './policy-modification-options';

interface PolicyModificationCardsProps extends Pick<GridProps, '$mt'> {
  policy: PolicySummaryFacade;
  user: UserAccountSummary;
  isAdmin?: boolean;
}

export function PolicyModificationCards({ policy, user, isAdmin = false, ...gridProps }: PolicyModificationCardsProps) {
  const translator = useTranslator();
  const { t } = translator;

  return (
    <Grid $gridTemplateColumns={['auto', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} $gridGap={3} {...gridProps}>
      {policyModificationOptions
        .filter((option) => {
          // If is admin, don't show redirection types
          if (isAdmin && option.actionType === ActionType.Redirection) {
            return false;
          }

          // If productTypes is not defined, always show this option
          if (!option.productTypes) {
            return true;
          }

          // Otherwise, only show the option for the policy's product type
          return option.productTypes?.includes(policy.productType);
        })
        .map((option) => (
          <PolicyModificationCard
            key={option.type}
            title={t(`policies.modification.options.${option.type}.title`)}
            desc={t(`policies.modification.options.${option.type}.subtitle`)}
            config={option}
            user={user}
            policyInfo={policy}
          />
        ))}
    </Grid>
  );
}
